// extracted by mini-css-extract-plugin
export var body = "U5XwXxY6MAEUhew6qxNV";
export var hero = "VeKfV5ShlVmRKRgWAg3j";
export var large = "rXWQMsr661FEf7qrk5vw";
export var micro = "nuLY5QSNXM4EIb6oAqEy";
export var mini = "d1bgJMxjURtaeTv5UNlW";
export var small = "dqarqXnsD7KSmiMTwhGv";
export var title1 = "boutSxSxZh1qeiOegGJA";
export var title2 = "vVN85Wx_gBeiplhXGAX6";
export var title3 = "aEr5yKAbf9cYjTfzBFDt";